import React from "react";
import AppRoutes from "./routes/Routes";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "./Customer/pages/customer-theme.css";
import WhatsAppWidget from "./Customer/pages/WhatsAppWidget";


function App() {
  return (
    
    <div className="App">
     <WhatsAppWidget/>

    <AppRoutes/>
    </div>
  );
}

export default App;
